

export function authHeader() {
    // return authorization header with jwt token
    let token = localStorage.getItem('token');
    const authHead = {
        'da-secret': 'pCweb',
        'Content-Type': 'application/json' 
    }

    if (token) {
        authHead['Authorization'] = 'Bearer ' + token;
        return authHead;
    } else {
        return authHead;
    }
}
